import { z } from "zod";
import { TranslationFunction } from "../../../utils/utils";

export const signUpSchema = (t: TranslationFunction) =>
  z
    .object({
      email: z.string().email(t("auth.errors.invalidEmail")),
      password: z
        .string()
        .min(6, "auth.errors.passwordLength")
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, "auth.errors.passwordFormat"),
      confirmPassword: z.string(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t("auth.errors.passwordMatch"),
      path: ["confirmPassword"],
    });

export const loginSchema = (t: TranslationFunction) =>
  z.object({
    email: z.string().email(t("auth.errors.invalidEmail")),
    password: z.string().min(1, t("auth.errors.passwordRequired")),
  });

export const forgotPasswordSchema = (t: TranslationFunction) =>
  z.object({
    email: z.string().email(t("auth.errors.invalidEmail")),
  });

export const resetPasswordSchema = (t: TranslationFunction) =>
  z.object({
    password: z
      .string()
      .min(6, t("auth.errors.passwordLength")),
    // .regex(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
    //   t("auth.errors.passwordFormat"),
    // ),
    confirmPassword: z.string(),
  })
    .refine((data) => data.password === data.confirmPassword, {
      message: t("auth.errors.passwordMatch"),
      path: ["confirmPassword"],
    });

export type SignUpInput = z.infer<ReturnType<typeof signUpSchema>>;
export type LoginInput = z.infer<ReturnType<typeof loginSchema>>;
export type ForgotPasswordInput = z.infer<
  ReturnType<typeof forgotPasswordSchema>
>;
export type ResetPasswordInput = z.infer<
  ReturnType<typeof resetPasswordSchema>
>;
